import { FC, ReactNode } from 'react'

export const CheckboxItemContainerP: FC<{ disabled: boolean; children: ReactNode }> = ({ children, ...props }) => (
  <label {...props}>{children}</label>
)
